import React from 'react';
import {shallowEqual, useSelector} from 'react-redux';
import {Footer} from "../../../_common/components/Footer/Footer";

export const PaymentsFooter = () => {
  const {count} = useSelector(
    (state) => ({count: state.payments.totalCount}),
    shallowEqual
  );

  return <Footer count={count}/>
};
